import { APITransport } from '@client/transports/api';

export const FusionService = {
  getAll(query = {}) {
    return APITransport.get({
      path: '/rest/domain/report/fusiondata2',
      query
    });
  }
};
